import axios from 'axios'

function buildParams(filters = {}) {
    const params = {
        fromDate: filters.fromDate,
        toDate: filters.toDate,
    }

    if (filters.specialityId) params.specialityId = filters.specialityId
    if (filters.insurancePlanId) params.insurancePlanId = filters.insurancePlanId
    if (filters.zip) params.zip = filters.zip
    if (filters.state) params.state = filters.state

    return params
}

export default {
    getOverview(filters) {
        return axios.get('/intelligence/overview', {
            params: buildParams(filters),
        })
    },

    getConstraints(filters) {
        return axios.get('/intelligence/constraints', {
            params: buildParams(filters),
        })
    },

    getDelivery(filters) {
        return axios.get('/intelligence/delivery', {
            params: buildParams(filters),
        })
    },

    getSupplyDemand(filters) {
        return axios.get('/intelligence/supply-demand', {
            params: buildParams(filters),
        })
    },

    getEntitlement(filters) {
        return axios.get('/intelligence/entitlement', {
            params: buildParams(filters),
        })
    },

    getPatientFriction(filters) {
        return axios.get('/intelligence/patient-friction', {
            params: buildParams(filters),
        })
    },

    getProviderPerformance(filters) {
        return axios.get('/intelligence/provider-performance', {
            params: buildParams(filters),
        })
    },

    getProviderCompetition(filters) {
        return axios.get('/intelligence/provider-competition', {
            params: buildParams(filters),
        })
    },
}
